/**
 * The Platform that the application is running on, and that Listings are being published to.
 */
export enum TargetPlatform {
  HOMEGATE = 'homegate',
  IS24 = 'immoscout24',
}

/**
 * The build target environment variable for each platform.
 */
export const EnvBuildTarget = {
  [TargetPlatform.HOMEGATE]: 'hg',
  [TargetPlatform.IS24]: 'is24',
};

/**
 * Returns the current platform that the user is on.
 */
export function getCurrentPlatform(): TargetPlatform {
  const buildTarget = import.meta.env.VUE_APP_BUILD_TARGET!;
  if (buildTarget === EnvBuildTarget[TargetPlatform.IS24]) {
    return TargetPlatform.IS24;
  } else {
    return TargetPlatform.HOMEGATE;
  }
}

/**
 * Returns true if the environment is production.
 */
export function isProduction(): boolean {
  return import.meta.env.VUE_APP_STAGE === 'prod';
}
